export default __webpack_public_path__ + "static/media/social.46fbff83.jpeg";